// removed by extract-text-webpack-plugin
module.exports = {"modal":"gq_gr","iframe":"gq_gs","close":"gq_gt","overlay":"gq_gu"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/VideoPortal/styles.module.css
// module id = 1309
// module chunks = 27